
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IdeaCurrentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ideaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availableTokenCount"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canComment"},"name":{"kind":"Name","value":"canAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"StringValue","value":"idea_comments","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"StringValue","value":"write","block":false}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canCommentAnonymously"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canDownloadIdeaPdf"},"name":{"kind":"Name","value":"canAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"StringValue","value":"idea_pdf_download","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"StringValue","value":"view","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canManageMessages"},"name":{"kind":"Name","value":"canAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"StringValue","value":"messages","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"StringValue","value":"manage","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canRateIdeas"},"name":{"kind":"Name","value":"canAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"StringValue","value":"ratings","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"StringValue","value":"write","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canViewIdeas"},"name":{"kind":"Name","value":"canAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"StringValue","value":"ideas","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"StringValue","value":"view","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canViewUserDetails"},"name":{"kind":"Name","value":"canAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"StringValue","value":"user_details","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"StringValue","value":"view","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canWriteIdeas"},"name":{"kind":"Name","value":"canAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"StringValue","value":"ideas","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"StringValue","value":"write","block":false}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ideaRating"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ideaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ideaId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAllocator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPaladin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isRetail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mostRecentEmployer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentEmployer"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":837}};
    doc.loc.source = {"body":"query IdeaCurrentUser($ideaId: ID!) {\n  currentUser {\n    id\n    availableTokenCount\n    canComment: canAccess(resource: \"idea_comments\", permission: \"write\")\n    canCommentAnonymously\n    canDownloadIdeaPdf: canAccess(resource: \"idea_pdf_download\", permission: \"view\")\n    canManageMessages: canAccess(resource: \"messages\", permission: \"manage\")\n    canRateIdeas: canAccess(resource: \"ratings\", permission: \"write\")\n    canViewIdeas: canAccess(resource: \"ideas\", permission: \"view\")\n    canViewUserDetails: canAccess(resource: \"user_details\", permission: \"view\")\n    canWriteIdeas: canAccess(resource: \"ideas\", permission: \"write\")\n    ideaRating(ideaId: $ideaId) {\n      id\n      score\n    }\n    isAdmin\n    isAllocator\n    isPaladin\n    isRetail\n    mostRecentEmployer {\n      id\n      currentEmployer\n    }\n    profileImageUrl\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["IdeaCurrentUser"] = oneQuery(doc, "IdeaCurrentUser");
        
